import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { NewInputNumber, parseFinalFormErrors } from '@saucelabs/sl-component-form';
import validate from '@saucelabs/sl-util-validate';

const constraints = { virtual_machines: { presence: { allowEmpty: false } } };

const SetGroupConcurrencyForm = ({
  formHandler,
  initialValues,
  maxVM,
  setConcurrency,
}) => (
  <Form
    initialValues={initialValues}
    onSubmit={(values) => (
      setConcurrency(values)
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => parseFinalFormErrors(response.data))
    )}
    render={({ handleSubmit }) => {
      formHandler.submit = handleSubmit; // eslint-disable-line no-param-reassign

      return (
        <form onSubmit={handleSubmit}>
          <Field
            component={NewInputNumber}
            initialValue={initialValues.virtual_machines}
            maxValue={maxVM}
            name="virtual_machines"
          />
        </form>
      );
    }}
    validate={(values) => validate(values, constraints, { format: 'grouped' })}
  />
);

SetGroupConcurrencyForm.propTypes = {
  formHandler: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  initialValues: PropTypes.shape({
    virtual_machines: PropTypes.number,
  }).isRequired,
  maxVM: PropTypes.number.isRequired,
  setConcurrency: PropTypes.func.isRequired,
};

export default SetGroupConcurrencyForm;
export { SetGroupConcurrencyForm };
